import type { VoidFunctionComponent } from 'react';

import { DISABLE_ADD_PROJECT_BUTTON } from '../../../shared/featureFlags/flagNames';
import { isFeatureEnabled } from '../../helpers/features';
import { Icon, icons, Link, NavigationButton, TooltipButton } from '../generic';

import styles from './IssueOverview.module.less';

const FOSSA_CLI_URL = 'https://github.com/fossas/fossa-cli?tab=readme-ov-file#getting-started';

const NoProjectsContent: VoidFunctionComponent = () => {
  const isAddProjectButtonDisabled = isFeatureEnabled(DISABLE_ADD_PROJECT_BUTTON);

  return (
    <div className={styles.noProjects}>
      This is where we&apos;ll show you an overview of issues we&apos;ve detected.
      <br />
      {isAddProjectButtonDisabled ? (
        <>Use the <Link to={FOSSA_CLI_URL} openInNewTab>FOSSA CLI</Link> to add projects.</>
      ) : (
        'Get started by importing your first project.'
      )}

      <div className={styles.addProjectsButton}>
        {isAddProjectButtonDisabled ? (
          <TooltipButton
            id="disabled-add-projects-button"
            size="medium"
            isDisabled
            showTooltip
            tooltip="Disabled by your admins"
            onClick={() => {}}
          >
            <Icon icon={icons.plus} /> Add Projects
          </TooltipButton>
        ) : (
          <NavigationButton to="/projects/import" size="medium">
            <Icon icon={icons.plus} /> Add Projects
          </NavigationButton>
        )}
      </div>
    </div>
  );
};

export default NoProjectsContent;
